import cache from './cache'
import drawingLayerTypes from 'helpers/enums/drawingLayerTypes'

const answer_prefix = 'Answer:'

function generateSessionKey(presentation_uid, session_uid, join_token, pincode) {
	return `${answer_prefix}${presentation_uid}_${session_uid}_${join_token}_${pincode}`
}

async function saveQuestionDataInCache(newAnswers, presentation_uid, session_uid, join_token, pincode) {
	if (newAnswers) {
		const sessionCacheKey = generateSessionKey(
			presentation_uid,
			session_uid,
			join_token,
			pincode
		)
		const currentAnswers = await cache.get(sessionCacheKey) || []

		const answersForCache = [...currentAnswers]
		Object.keys(newAnswers).forEach(key => {
			const current_index = currentAnswers.findIndex(
				answer => `${answer_prefix}${key}` === answer.key
			)
			if (current_index > -1) {
				answersForCache[current_index].value = newAnswers[key]
			} else {
				answersForCache.push({
					key: `${answer_prefix}${key}`,
					value: newAnswers[key],
				})
			}
		})

		await cache.set(sessionCacheKey, answersForCache)
	}
}

async function saveDrawItDataInCache(
	answers,
	presentation_uid,
	session_slide_uid,
	pincode
) {
	const sessionCacheKey = generateSessionKey(
		presentation_uid,
		session_slide_uid,
		'',
		pincode
	)

	const localImageActions = answers.filter(
		answer =>
			answer.type === drawingLayerTypes.IMAGE
			&& answer.file.type === 'local'
	)

	const answersForCache = {
		actions: !localImageActions.length ? answers : [],
		key: sessionCacheKey,
	}
	await cache.set(`storedDrawIt_${session_slide_uid}`, answersForCache)

}

async function getDrawItDataInCache(
	presentation_uid,
	session_slide_uid,
	pincode
) {
	const sessionCacheKey = generateSessionKey(
		presentation_uid,
		session_slide_uid,
		'',
		pincode
	)
	const currentDrawIt = await cache.get(`storedDrawIt_${session_slide_uid}`)
	if (currentDrawIt && currentDrawIt.key === sessionCacheKey) {
		return currentDrawIt
	}
	return {
		actions: [],
	}
}

async function getAnswersDataFromCache(answer_ids, presentation_uid, session_uid, join_token, pincode) {

	const sessionCacheKey = generateSessionKey(
		presentation_uid,
		session_uid,
		join_token,
		pincode
	)
	const currentAnswers = await cache.get(sessionCacheKey) || []

	const answers = []
	answer_ids.forEach(key => {
		const current_index = currentAnswers.findIndex(
			answer => `${answer_prefix}${key}` === answer.key
		)
		if (current_index > -1) {
			const currentAnswer = currentAnswers[current_index]
			answers.push(currentAnswer)
		}
	})
	return answers
}

async function saveData(key, data) {
	return cache.set(key, data)
}

async function getData(key) {
	return cache.get(key)
}

export {
	saveQuestionDataInCache,
	getAnswersDataFromCache,
	saveDrawItDataInCache,
	getDrawItDataInCache,
	saveData,
	getData,
}
